<template>
  <b-row>
    <b-col cols="12">
      <b-card>
        <b-overlay
            variant="white"
            :show="showLoading"
            spinner-variant="primary"
            blur="0"
            opacity=".75"
            rounded="sm"
        >
          <div class="p-1">
            <form class="" @submit.prevent="submitForm">
              <div class="row">
                <div class="form-group col-12 col-md-3">
                  <label for="phone24">Nombre:</label>
                  <b-form-input v-model="ocatype.name" autocomplete="off"/>
                  <span v-if="validation_ocatype.name" class="text-danger">
                                      {{ validation_ocatype.name }}
                                    </span>
                </div>
              </div>
              <div class="row">
                <button type="submit" class="btn btn-primary col-12 col-md-1 ml-1 mt-2">
                  Guardar
                </button>
              </div>
            </form>
          </div>
        </b-overlay>
      </b-card>
    </b-col>
  </b-row>
</template>
<script>
import {BCard, BCol, BOverlay, BRow, BFormInput} from 'bootstrap-vue'
import {mapState} from "vuex"
import {GEI_AUXILIAR_OCA_TYPES_LIST} from "@/router/web/constants"
import {createHelpers} from "vuex-map-fields"

import helper from "@/resources/helpers/helpers"

const {mapFields} = createHelpers({
  getterType: 'auxiliariesOcaType/getField',
  mutationType: 'auxiliariesOcaType/updateField',
})

export default {
  name: "formView",
  components: {
    BCol,
    BRow,
    BCard,
    BFormInput,
    BOverlay,
  },
  data() {
    return {
      edit: false,
      showLoading: false,
    }
  },
  computed: {
    ...mapState('auxiliariesOcaType', ['validation_ocatype']),
    ...mapFields({
      ocatype: 'ocatype',
    }),
  },
  created() {
    this.$store.commit('auxiliariesOcaType/RESET_STATE')
    this.$store.commit('auxiliariesOcaType/CLEAR_VALIDATION')
    if (this.$route.params.id) {
      this.edit = true
      this.getOcaType()
    } else {
      this.edit = false
    }
    this.$root.$refs.auxiliariesOcaTypeForm = this
  },
  methods: {
    getOcaType() {
      this.showLoading = true
      this.$store.dispatch('auxiliariesOcaType/findOcaType', {
        id: this.$route.params.id ?? this.ocatype.id
      })
          .then(response => {
            this.showLoading = false
          })
          .catch(error => {
            this.showLoading = false
          })
    },
    cancel() {
      this.$router.push(GEI_AUXILIAR_OCA_TYPES_LIST)
    },
    createOcaType() {
      this.$store.dispatch('auxiliariesOcaType/createOcaType', this.ocatype)
          .then(response => {
            helper.showToast('Tipo de oca creado correctamente!', 'CheckIcon', 'success')
            this.$router.replace(GEI_AUXILIAR_OCA_TYPES_LIST)
          })
          .catch(error => {
            helper.showToast('Error al crear el tipo de oca', 'AlertOctagonIcon', 'danger')
            console.log(error)
          })
    },
    updateOcaType() {
      this.$store.dispatch('auxiliariesOcaType/updateOcaType', this.ocatype)
          .then(response => {
            helper.showToast('Tipo de oca editado correctamente!', 'CheckIcon', 'success')
            this.$router.replace(GEI_AUXILIAR_OCA_TYPES_LIST)
          })
          .catch(error => {
            helper.showToast('Error al editar el tipo de oca', 'AlertOctagonIcon', 'danger')
            console.log(error)
          })
    },
    submitForm() {
      if (this.$route.params.id) {
        this.updateOcaType()
      } else {
        this.createOcaType()
      }
    },
  },
}
</script>